import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 bg-dark-bg border-y border-white/10 relative overflow-hidden" data-id="element-30">
      <div className="absolute inset-0 bg-grid-pattern opacity-20" data-id="element-31"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-32">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-4xl mx-auto bg-gradient-to-br from-panel-bg to-black border-2 border-electric-blue/30 rounded-3xl p-10 md:p-16 text-center box-glow-blue relative overflow-hidden" data-id="element-33">
          <div className="absolute -top-20 -right-20 w-64 h-64 bg-electric-blue/10 rounded-full blur-3xl" data-id="element-34"></div>
          <div className="absolute -bottom-20 -left-20 w-64 h-64 bg-electric-blue/10 rounded-full blur-3xl" data-id="element-35"></div>

          <ShieldCheck className="w-24 h-24 text-electric-blue mx-auto mb-8 drop-shadow-[0_0_15px_rgba(0,170,255,0.5)]" data-id="element-36" />

          <h2 className="text-5xl md:text-6xl font-teko font-bold text-white mb-6" data-id="element-37">
            PROBALO SIN <span className="text-electric-blue" data-id="element-38">RIESGO</span>
          </h2>

          <p className="text-2xl text-white font-bold mb-4" data-id="element-39">
            Garantía de satisfacción de 7 días.
          </p>

          <p className="text-lg text-gray-400 font-medium max-w-2xl mx-auto" data-id="element-40">
            Si el material no cumple tus expectativas, podés solicitar
            asistencia dentro del período de garantía. Tu tranquilidad es
            nuestra prioridad.
          </p>
        </motion.div>
      </div>
    </section>;
}